import {type} from '@clients/shared/utilities';
import {Action} from '@clients/shared/models';
import {ISurveyValidationSuccessApiResponse} from '../../../models/api-responses/SurveyValidateApiResponse.interface';
import {ISurveyConfig} from '../../../models/survey/ISurveyConfig';
import {SurveyLoadedPayload} from '../../../models/survey/ISurveyLoadedPayload';
import { ShareLinkPayload } from '../../../models/survey-responses/ShareLinkPayload.interface';
import { IUIInteractionDetail } from '../../../models/survey/IUIInteractionDetail';

export const SurveyActionTypes = {
    RESET: type('[surveys] reset'),

    VALIDATE_SURVEY: type('[surveys] bootstrap survey'),
    SURVEY_VALIDATION_SUCCESS: type('[surveys] validation succeeded'),
    SURVEY_VALIDATION_FAILURE: type('[surveys] validation failed'),

    SET_LANGUAGE: type('[surveys] set the survey language'),

    LOAD_SURVEY: type('[surveys] load survey'),
    SURVEY_LOADED: type('[surveys] survey loaded'),
    SURVEY_LOAD_FAILED: type('[surveys] survey load failed'),
    SURVEY_ON_LOAD_PROCESSED: type('[surveys] survey on load processed'),
    SURVEY_CONFIG_LOADED: type('[surveys] survey config loaded'),

    SURVEY_START: type('[surveys] survey start'),

    COMPLETE_SURVEY: type('[surveys] complete survey'),
    SURVEY_COMPLETED: type('[surveys] survey completed'),

    DISABLE_RESUME: type('[surveys] disable resume'),

    BLOCK_ON_PARAMS: type("[blocks] block on route params"),

    LOAD_MEMBER_CONTACT: type("[surveys] get member contact info"),
    MEMBER_CONTACT_LOADED: type("[surveys] member contact info loaded"),

    SEND_CONTACT: type("[surveys] send contact"),
    SEND_CONTACT_FAILURE: type("[surveys] send contact failure"),
    SEND_CONTACT_SUCCESS: type("[surveys] send contact success"),
    TRACKING_ACTION: type("[surveys] tracking action"),
};

/* istanbul ignore next */
export class ResetSurveyAction implements Action {
    public readonly type: string = SurveyActionTypes.RESET;
}

export class ValidateSurveyAction implements Action<string> {
    public readonly type: string = SurveyActionTypes.VALIDATE_SURVEY;

    // context
    constructor(public payload: string) {}
}

export class SurveyValidationSuccessAction implements Action<ISurveyValidationSuccessApiResponse> {
    public readonly type: string = SurveyActionTypes.SURVEY_VALIDATION_SUCCESS;

    constructor(public payload: ISurveyValidationSuccessApiResponse) {}
}

export class SurveyValidationFailureAction implements Action<any> {
    public readonly type: string = SurveyActionTypes.SURVEY_VALIDATION_FAILURE;

    // error response
    constructor(public payload: any) {}
}

export class LoadSurveyAction implements Action<string> {
    public readonly type: string = SurveyActionTypes.LOAD_SURVEY;

    // surveyId
    constructor(public payload: string) {}
}

export class SetLanguageAction implements Action<string> {
    public readonly type: string = SurveyActionTypes.SET_LANGUAGE;

    // language code
    constructor(public payload: string) {}
}

export class SurveyLoadedAction implements Action<SurveyLoadedPayload> {
    public readonly type: string = SurveyActionTypes.SURVEY_LOADED;

    constructor(public payload: SurveyLoadedPayload) {}
}

export class SurveyLoadFailedAction implements Action<any> {
    public readonly type: string = SurveyActionTypes.SURVEY_LOAD_FAILED;

    // todo | interface for error https://healthtel.atlassian.net/browse/SB-995
    constructor(public payload: any) {}
}

export class SurveyOnLoadProcessedAction implements Action {
    public readonly type: string = SurveyActionTypes.SURVEY_ON_LOAD_PROCESSED;
}

export class SurveyConfigLoadedAction implements Action<ISurveyConfig> {
    public readonly type: string = SurveyActionTypes.SURVEY_CONFIG_LOADED;

    constructor(public payload: ISurveyConfig) {}
}

export class SurveyStartAction implements Action<SurveyLoadedPayload> {
    public readonly type: string = SurveyActionTypes.SURVEY_START;

    constructor(public payload: SurveyLoadedPayload) {}
}

/* istanbul ignore next */
export class CompleteSurveyAction implements Action {
    public readonly type: string = SurveyActionTypes.COMPLETE_SURVEY;
}

export class SurveyCompletedAction implements Action {
    public readonly type: string = SurveyActionTypes.SURVEY_COMPLETED;
}

export class DisableSurveyResumeAction implements Action {
    public readonly type: string = SurveyActionTypes.DISABLE_RESUME;
}

export class BlockOnParamsAction implements Action<string|null> {
    public type: string = SurveyActionTypes.BLOCK_ON_PARAMS;

    constructor(public payload: string|null) {}
}

export class LoadMemberContact
  implements Action<{ memberId: string; shortCode: string }>
{
  public readonly type: string = SurveyActionTypes.LOAD_MEMBER_CONTACT;

  // surveyId
  constructor(public payload: { memberId: string; shortCode: string }) {}
}

export class MemberContactLoaded implements Action<object> {
    public readonly type: string = SurveyActionTypes.MEMBER_CONTACT_LOADED;

    constructor(public payload: object) {}
}

export class SendContactAction
  implements
    Action<{
      memberId: string;
      shortCode: string;
      data: ShareLinkPayload;
    }>
{
  readonly type = SurveyActionTypes.SEND_CONTACT;
  constructor(
    public payload: {
      memberId: string;
      shortCode: string;
      data: ShareLinkPayload;
    },
  ) {}
}

export class SendContactFailureAction implements Action {
  readonly type = SurveyActionTypes.SEND_CONTACT_FAILURE;
  constructor(public payload: any) {}
}

export class SendContactSuccessAction implements Action {
  readonly type = SurveyActionTypes.SEND_CONTACT_SUCCESS;
  constructor(public payload: any) {}
}

export class SurveyTrackingAction implements Action<IUIInteractionDetail> {
    readonly type = SurveyActionTypes.TRACKING_ACTION;
    constructor(public payload: IUIInteractionDetail) { }
}
